<script setup lang="ts">
import { computed, reactive, unref } from 'vue';

import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import { LpNotifications, LpSetup } from '@thehotelsnetwork/lampo';
import messages from '@thehotelsnetwork/lampo/dist/locales';
import { useI18n } from 'vue-i18n';

const route = useRoute();

useHead({
  title: computed(() => unref(route.meta.title) as string),
});

const { locale } = useI18n();

const lampoLang = computed(() => {
  const langList: Record<typeof locale.value, string> = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    it: 'it-IT',
    de: 'de-DE',
    pt: 'pt-PT',
    sv: 'sv-SE',
    th: 'th-TH',
    ja: 'ja-JP',
  };

  return langList[locale.value] || langList.en;
});

const lampoConfig = reactive({
  locale: lampoLang,
  messages,
});
</script>
<template>
  <LpSetup :config="lampoConfig">
    <router-view />
    <LpNotifications class="notifications" />
  </LpSetup>
</template>
<style scoped>
.notifications {
  z-index: 9999999999 !important;
}
</style>
